export default __webpack_public_path__ + "static/media/ada.8753647d.svg";